import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    CssBaseline,
    Fab,
    ThemeProvider, ToggleButton,
    Typography
} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFnsJalali} from "@mui/x-date-pickers/AdapterDateFnsJalali";
import React from "react";
import {Provider} from "react-redux";
import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import "./App.css";
import setupOpenApi from "./api/config";
import AppRoutes from "./components/AppRoutes";
import AuthenticationProvider from "./providers/AuthenticationProvider";
import IntegrationProvider from "./providers/IntegrationProvider";
import {store} from "./slices/Store";
import {customizeTheme} from "./utils/theme";

import {QueryClient, QueryClientProvider} from "react-query";

const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});

setupOpenApi();

export default function App() {


    const themeValue = React.useMemo(() => {
        return customizeTheme(
            (localStorage.getItem("theme") as "light" | "dark") ?? "light"
        );
    }, [localStorage.getItem("theme")]);

    const queryClient = new QueryClient();

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={themeValue}>
                <CssBaseline/>
                <Provider store={store}>
                    <AuthenticationProvider>
                        <IntegrationProvider>
                            <LocalizationProvider
                                dateAdapter={AdapterDateFnsJalali}>
                                <QueryClientProvider client={queryClient}>
                                    <AppRoutes/>
                                </QueryClientProvider>
                            </LocalizationProvider>
                        </IntegrationProvider>
                    </AuthenticationProvider>
                </Provider>
            </ThemeProvider>
        </CacheProvider>
    );
}
